import axios from "axios";

const urlPath = "instalacionKae";

export const createInstalacion = async (data) => {
  console.log(data)

  try {
    const response = await axios.post(urlPath, data);

    return response.data;
  } catch (err) {
    console.log(err);
    return(err);
  }
};

export const createVisitaInstalacion = async (data, imagenes = []) => {
  try {
    const formData = new FormData();
    formData.append("instalacion_id", data.instalacion_id);
    formData.append("productos", JSON.stringify(data.productos || []));
    if (data.observaciones !== undefined) {
      formData.append("observaciones", data.observaciones ?? "");
    }
    (imagenes || []).forEach((file) => {
      formData.append("images", file);
    });
    const response = await axios.post(`${urlPath}/visita`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (err) {
    console.log(err);
    return err?.response || err;
  }
};

export const getAllInstalaciones = async () => {
  try {
    const response = await axios.get(urlPath);

    return response.data;
  } catch (err) {
    console.log(err);
  }
};
export const getInstalaciones = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/filter`, data.filtros, {
      params: data.params 
    });
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const getInstalacion = async (nif) => {
  try {
    const response = await axios.get(`${urlPath}/${nif}`);

    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const noRealizadaKae = async (id, data) => {
  try {
    const response = await axios.put(`${urlPath}/notVisitKae/${id}`, data);

    return response;
  } catch (error) {
    console.log(error);
    return error?.response || error;
  }
};

export const updateInstalacion = async (id, data, imagenes = [], imagenesABorrar = []) => {
  try {
    const tieneImagenes = (imagenes && imagenes.length) || (imagenesABorrar && imagenesABorrar.length);
    if (!tieneImagenes) {
      const response = await axios.put(`${urlPath}/${id}`, data);
      return response;
    }
    const formData = new FormData();
    Object.entries(data || {}).forEach(([key, value]) => {
      if (value === undefined) return;
      if (key === 'productos') {
        formData.append('productos', JSON.stringify(value ?? []));
        return;
      }
      if (value === null) {
        formData.append(key, '');
        return;
      }
      if (typeof value === 'object') {
        formData.append(key, JSON.stringify(value));
        return;
      }
      formData.append(key, value);
    });
    (imagenes || []).forEach((file) => {
      formData.append('images', file);
    });
    if (imagenesABorrar && imagenesABorrar.length) {
      formData.append(
        'images_to_delete',
        JSON.stringify(imagenesABorrar.map((img) => ({ id: img.id, ruta: img.ruta || img.path })))
      );
    }
    const response = await axios.put(`${urlPath}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
};

export const getTecnicosKae = async () => {
  try {
    const response = await axios.get(`${urlPath}/tecnicos`);
    return response.data;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const exportarInstalacionesKae = async (filtros) => {
  try {
    const response = await axios.post(
      `${urlPath}/exportar`,
      filtros || {},
      {
        responseType: "blob",
        headers: {
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      }
    );
    if (response.data?.type === "application/json") {
      const text = await response.data.text();
      const error = JSON.parse(text);
      throw new Error(error.error || "Error al exportar");
    }
    return response.data;
  } catch (err) {
    console.log(err.response || err);
    throw err;
  }
};

export const getAaffsKae = async (razonSocial) => {
  try {
    const response = await axios.get(`${urlPath}/aaffs`, {
      params: razonSocial ? { razonSocial } : {},
    });
    return response.data;
  } catch (err) {
    console.log(err);
    return [];
  }
};

export const deleteInstalacion = async (id) => {
  try {
    const response = await axios.delete(`${urlPath}/${id}`);
    return response.data;
  } catch (err) {
    console.log(err);
  }
};

export const importarFechaFactura2Kae = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await axios.post(
    `${urlPath}/importar-fecha-factura2`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
      },
    }
  );
  return response.data;
};